module.exports = __webpack_public_path__ + "static/widget-img-4-7175dc8ed9154c26ec482b64bef1b5c9.png";